export const API_BACKEND_HOST = import.meta.env.VITE_API_BACKEND_HOST
export const API_FEEDBACKS_HOST = import.meta.env.VITE_API_FEEDBACKS_HOST
export const WEBSOCKET_HOST = import.meta.env.VITE_WEBSOCKET_HOST
export const GOOGLE_AUTH_URL = `${API_BACKEND_HOST}/auth/google_token`
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID
export const HUB_APP_HOST = import.meta.env.VITE_HUB_APP_HOST
export const APP_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
export const EDUCATION_LINK = 'https://edu.dfuture.co/'
export const WIKI_LINK = import.meta.env.VITE_WIKI_LINK
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const GITLAB_API_CORE_TOKEN = 'glpat-vqygjW7XAAyPRvMekrYj' // expired on 2025-12-31
export const GITLAB_API_FRONTEND_TOKEN = 'glpat-S-tBGmnk5C-pDaQ4Xkz5' // expired on 2025-12-31
export const GITLAB_API_FEEDBACKS_TOKEN = 'glpat-V91i1MSycx1vusP3Wvku' // expired on 2025-12-31
export const GITLAB_API_HUB_TOKEN = 'glpat-WWwuq6kmpWUVDHXpeUzv' // expired on 2025-12-31
